import styles from "../../_styles/InfoBlock.module.scss";
import { infoBlockItems } from "../../../../constants/structure";
import InfoBlockIcons from "./InfoBlockIcons";
import React from "react";
import { useTranslation } from "react-i18next";
import { setCountFeed } from "../../../../store/slices/feed.slice";
import { useDispatch } from "react-redux";
import { setLoginModal } from "../../../../store/slices/modals.slice";
import useAnotherGaEvents from "../../../../utils/hooks/useAnotherGaEvents";

interface IProps {
  isMobile?: boolean;
  likeHandler: (e: any, item: any, flag: boolean) => void;
  favouritesHandler: (e: any, item: any, flag: boolean) => void;
  reviewHandler: () => void;
  liked: boolean;
  inFavourites: boolean;
  shared: boolean;
  item: any;
  shareHandler: () => void;
}

const ChooseInfoBlock = ({
  isMobile,
  likeHandler,
  reviewHandler,
  favouritesHandler,
  liked,
  shared,
  inFavourites,
  item,
  shareHandler,
}: IProps) => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const { trackLike, trackBookmark, trackShare } = useAnotherGaEvents();

  const valueHandler = (path: string, def: any) => {
    if (path === "likes") {
      return item?.vote_count;
    }
    if (path === "secondaryShare") {
      return item?.shares_count;
    }

    if (path === "saved") {
      return item?.favorites_count;
    }

    return def;
  };

  const updateLocalCount = (id: any, key: any, type: any) => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    dispatch(setCountFeed({ id, key, type }));
  };

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div className={`${isMobile ? styles.itemInfoBarMobile : styles.itemInfoBar}`}>
      {infoBlockItems.map((infoBlockItem, index) => {
        return (
          <div
            id={infoBlockItem.path}
            key={infoBlockItem.path}
            onClick={(e) => {
              const token = localStorage.getItem("accessToken");

              if (infoBlockItem.handler === "like") {
                if (!token) {
                  dispatch(setLoginModal(true));
                  return;
                }

                updateLocalCount(item.id, "vote_count", liked ? "decrement" : "increment");
                trackLike(item.title);
                return likeHandler(e, item, liked);
              }

              if (infoBlockItem.handler === "saved") {
                if (!token) {
                  dispatch(setLoginModal(true));
                  return;
                }

                updateLocalCount(item.id, "favorites_count", inFavourites ? "decrement" : "increment");
                trackBookmark(item.title);
                return favouritesHandler(e, item, inFavourites);
              }

              if (infoBlockItem.handler === "share") {
                trackShare(item.title);
                return shareHandler();
              }
            }}
            className={`${styles.infoBarItemWrapper} ${isMobile ? styles.infoBarItemWrapperMobile : ""}`}
          >
            <div className={styles.infoBarContentWrapper}>
              <InfoBlockIcons
                dir={dirData}
                isMobile={isMobile}
                iconName={infoBlockItem.path}
                liked={liked}
                shared={shared}
                inFavourites={inFavourites}
              />
              <div>{valueHandler(infoBlockItem.path, infoBlockItem.number)}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ChooseInfoBlock;
